import { gql } from '@apollo/client'
import Page from '@components/common/Page'
import FaqPage from '@components/faq/FaqPage'
import { pageIds } from '@config/contentful'
import client from '@contentful/client'
import { faqFragment } from '@contentful/faq'
import RichTextBlock from '@models/projects/interfaces/richText.interface'
import { GetStaticProps } from 'next'
import React from 'react'

interface IndexProps {
  title: string
  faqs: {
    question: string
    answer: RichTextBlock
  }[]
}

const Index: React.FC<IndexProps> = ({ title, faqs }) => {
  return (
    <Page title={title}>
      <FaqPage title={title} faqs={faqs} />
    </Page>
  )
}

export const getStaticProps: GetStaticProps = async () => {
  const { data, error } = await client.query({
    query: gql`
      query FaqPageQuery($preview: Boolean!, $pageId: String!) {
        faQs(id: $pageId, preview: $preview) {
          ...faqFields
        }
      }
      ${faqFragment}
    `,
    variables: {
      preview: process.env.CONTENTFUL_PREVIEW_MODE,
      pageId: pageIds.faq
    },
    fetchPolicy: 'network-only'
  })

  return {
    props: {
      title: data.faQs.title || '',
      faqs: data?.faQs?.faqs?.items || [],
      error: error?.message || ''
    },
    revalidate: 60
  }
}

export default Index
